import { createActions, createState, createReducer } from 'reduxsauce-crud'
import R from 'ramda'

const d = { deep: true }

export const InventoryRedux = createActions(
  {
    postCheckInRequest: ['checkin_id', 'data'],
    postCheckInSuccess: ['data'],
    postCheckInFailure: ['errors'],
    updateInventoryRequest: ['checkinId', 'payload'],
    updateInventorySuccess: ['data'],
    updateInventoryFailure: ['errors'],
    postCheckOutRequest: ['checkin', 'data', 'isTeacher'],
    postCheckOutSuccess: ['checkin', 'data'],
    postCheckOutFailure: ['errors'],
    resetError: [],
    getStudentByNameRequest: ['name'],
    getStudentByNameSuccess: ['data'],
    getStudentByNameFailure: ['error'],
    clearSearchStudenByName: [],
    updateVirtualCheckin: ['data'],
  },
  {
    prefix: 'INVENTORY_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = InventoryRedux
export const InventoryTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
  new_check_out: {},
  search_student_vCheckin: {
    fetching: false,
    error: null,
    results: [],
  },
}, {
  get: true,
})

/* ------------- Reducers ------------- */
const resetError = state => state.merge({ create: { fetching: false, error: null } }, d)

const postCheckInRequest = state => state.merge({
  sending: {
    fetching: true,
    error: null,
  },
  new_checkin: {
    error: '',
    success: false,
  },
}, d)

const postCheckInSuccess = (state, { data }) => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
  new_checkin: {
    error: '',
    success: true,
  },
  ...data,
}, d)

const postCheckInFailure = (state, { errors }) => state.merge({
  sending: {
    fetching: false,
    error: errors,
  },
  new_checkin: {
    success: false,
    error: errors[0],
  },
}, d)

const postCheckOutRequest = state => state.merge({
  sending: {
    fetching: true,
    error: null,
  },
  new_check_out: {
    error: '',
    success: false,
  },
}, d)

const postCheckOutSuccess = (state, { data }) => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
  new_check_out: {
    error: '',
    success: true,
    ...data,
  },
}, d)

const postCheckOutFailure = (state, { errors }) => state.merge({
  sending: {
    fetching: false,
    error: errors,
  },
  new_check_out: {
    success: false,
    error: errors[0],
  },
}, d)

const getStudentByNameRequest = state =>
  state.merge({ search_student_vCheckin: { fetching: true, error: null } }, d)

const getStudentByNameSuccess = (state, { data }) =>
  state.merge({ search_student_vCheckin: { fetching: false, error: null, results: data } }, d)

const getStudentByNameFailure = (state, { error }) =>
  state.merge({ search_student_vCheckin: { fetching: false, error, results: [] } }, d)

const clearSearchStudenByName = state =>
  state.merge({ search_student_vCheckin: INITIAL_STATE.search_student_vCheckin }, d)

const updateVirtualCheckin = (state, { data }) => {
  if (data.status === 'checked in') {
    const newSearchStudent = R.clone(state.search_student_vCheckin.results)
    const studentIndex = R.findIndex(R.propEq('id', data.data.student.id))(newSearchStudent)
    const studentToUpdate = newSearchStudent[studentIndex]
    const checkinInfo = {
      checkin: {
        id: data.data.id,
        status: data.destination,
        is_virtual_center: data.destination.startsWith('Virtual Center'),
      },
      temperature: data.data.latest_health_check.temperature,
      is_virtual_center: data.destination.startsWith('Virtual Center'),
    }

    const studentUpdated = R.merge(studentToUpdate, checkinInfo)

    newSearchStudent[studentIndex] = studentUpdated
    return state.merge({ search_student_vCheckin: { results: newSearchStudent } }, d)
  } else if (data.status === 'sent home') {
    const newSearchStudent = R.clone(state.search_student_vCheckin.results)
    const studentIndex = R.findIndex(R.propEq('id', data.data.student.id))(newSearchStudent)

    const studentToUpdate = newSearchStudent[studentIndex]
    const checkinInfo = { checkin: { id: null, status: 'Home' }, temperature: data.data.temperature }
    const studentUpdated = R.merge(studentToUpdate, checkinInfo)

    newSearchStudent[studentIndex] = studentUpdated

    return state.merge({ search_student_vCheckin: { results: newSearchStudent } }, d)
  }
  return state
}

export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.postCheckInRequest]: postCheckInRequest,
    [Types.postCheckInSuccess]: postCheckInSuccess,
    [Types.postCheckInFailure]: postCheckInFailure,
    [Types.updateInventoryRequest]: postCheckInRequest,
    [Types.updateInventorySuccess]: postCheckInSuccess,
    [Types.updateInventoryFailure]: postCheckInFailure,
    [Types.postCheckOutRequest]: postCheckOutRequest,
    [Types.postCheckOutSuccess]: postCheckOutSuccess,
    [Types.postCheckOutFailure]: postCheckOutFailure,
    [Types.resetError]: resetError,
    [Types.getStudentByNameRequest]: getStudentByNameRequest,
    [Types.getStudentByNameSuccess]: getStudentByNameSuccess,
    [Types.getStudentByNameFailure]: getStudentByNameFailure,
    [Types.clearSearchStudenByName]: clearSearchStudenByName,
    [Types.updateVirtualCheckin]: updateVirtualCheckin,
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/InventoryRedux.js